import { render, staticRenderFns } from "./OffBoardingSelectedPersonTableTasks.vue?vue&type=template&id=56ae1a30&scoped=true&"
import script from "./OffBoardingSelectedPersonTableTasks.vue?vue&type=script&lang=js&"
export * from "./OffBoardingSelectedPersonTableTasks.vue?vue&type=script&lang=js&"
import style0 from "./OffBoardingSelectedPersonTableTasks.vue?vue&type=style&index=0&id=56ae1a30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ae1a30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VBtn,VContainer,VDataTable,VIcon,VSimpleCheckbox})
